// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useOperatorConfigurations: () => UseQueryResult<
  TemplateContract<OperatorConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  // COLLATERAL: fix
  const { operator } = useParties();
  return useQueryWithOffset({
    enabled: !!operator,
    queryKey: ['queryCollateralOperatorConfigurations', operator],
    queryFn: async (_, offset) => {
      return ledgerApi.queryCollateralOperatorConfigurations(offset, operator);
    },
  });
};

export default useOperatorConfigurations;
